import React, { useState, useRef, useEffect } from 'react';
import { Mail, Phone, Star, MoreVertical, Eye, Edit, Trash2, Send } from 'lucide-react';
import { StatusBadge, UserAvatar, AppBadge } from '../ui';

const InstructorCard = ({ instructor, onView, onEdit, onDelete, resendWelcomeEmail }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [menuOpen]);

  const courses = instructor.subject ? instructor.subject.split(',').map(c => c.trim()) : [];

  return (
    <div className="inst-card">
      {/* Header */}
      <div className="inst-card__header">
        <div className="inst-card__user">
          <UserAvatar name={instructor.name} size="lg" />
          <div>
            <span className="inst-card__name" onClick={() => onView(instructor)}>
              {instructor.name}
            </span>
            <span className="inst-card__subject">{instructor.subject}</span>
          </div>
        </div>
        <div className="inst-card__header-actions">
          <StatusBadge status={instructor.status?.toLowerCase() || 'active'}>
            {instructor.status || 'Active'}
          </StatusBadge>
          <div className="inst-menu" ref={menuRef}>
            <button className="inst-menu__trigger" onClick={() => setMenuOpen(v => !v)}>
              <MoreVertical size={16} />
            </button>
            {menuOpen && (
              <div className="inst-menu__dropdown">
                <button className="inst-menu__item" onClick={() => { setMenuOpen(false); onView(instructor); }}>
                  <Eye size={14} /> View Profile
                </button>
                <button className="inst-menu__item" onClick={() => { setMenuOpen(false); onEdit(instructor); }}>
                  <Edit size={14} /> Edit
                </button>
                <button className="inst-menu__item" onClick={() => { setMenuOpen(false); resendWelcomeEmail(instructor); }}>
                  <Send size={14} /> Resend Email
                </button>
                <button className="inst-menu__item inst-menu__item--danger" onClick={() => { setMenuOpen(false); onDelete(instructor); }}>
                  <Trash2 size={14} /> Remove
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Contact */}
      <div className="inst-card__contact">
        <div className="inst-card__contact-row">
          <Mail size={15} />
          <span className="text-truncate">{instructor.email}</span>
        </div>
        <div className="inst-card__contact-row">
          <Phone size={15} />
          <span>{instructor.mobile}</span>
        </div>
      </div>

      {/* Stats */}
      <div className="inst-card__stats">
        <div className="inst-card__stat">
          <span className="inst-card__stat-value inst-rating">
            <Star size={14} fill="currentColor" />
            {instructor.rating || '—'}
          </span>
          <span className="inst-card__stat-label">Rating</span>
        </div>
        <div className="inst-card__stat">
          <span className="inst-card__stat-value">{instructor.students || '—'}</span>
          <span className="inst-card__stat-label">Students</span>
        </div>
        <div className="inst-card__stat">
          <span className="inst-card__stat-value">{instructor.experience ? `${instructor.experience} yrs` : '—'}</span>
          <span className="inst-card__stat-label">Experience</span>
        </div>
      </div>

      {/* Courses */}
      <div className="inst-card__courses">
        {courses.length > 0 ? (
          courses.map((course, i) => (
            <AppBadge key={i} variant="secondary">{course}</AppBadge>
          ))
        ) : (
          <AppBadge variant="secondary">{instructor.subject || 'N/A'}</AppBadge>
        )}
      </div>
    </div>
  );
};

export default InstructorCard;
